<template>
    <RegisterStep
        :ready="ready"
        :loading="loading"
        v-bind="$attrs"
        @submit="handleStepSubmitted"
    >
        <template v-slot:title>
            Coordonnées
        </template>

        <template v-if="filteredAccounts && filteredAccounts.length > 0">
            <Field name="account_id" :errors="errors" v-slot="{ error }">
                <div class="card" :class="{ 'border-danger': error }" style="max-width: 600px">
                    <div class="list-group list-group-flush">
                        <template v-for="account in filteredAccounts">
                            <AccountItem
                                v-model="currentOrder.account_id"
                                :account="account"
                                @input="handleAccountSelected"
                            />
                        </template>
                        <div class="list-group-item list-group-item-action" role="button" @click="handleCreateClicked">
                            <div class="row align-items-center" style="--bs-gutter-x: .75rem">
                                <div class="col-auto">
                                    <div class="custom-control custom-radio">
                                        <input
                                            class="custom-control-input"
                                            name="account_id"
                                            type="radio"
                                            :value="null"
                                            :checked="!currentOrder.account_id && currentAccount"
                                            @change="handleCreateClicked"
                                            @click.stop
                                        >
                                        <div class="custom-control-label"></div>
                                    </div>
                                </div>
                                <div class="col">
                                    Nouvelles coordonnées...
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Field>
        </template>

        <template v-if="currentAccount">
            <div class="mt-4">
                <AccountForm
                    v-model="currentAccount"
                    :errors="errors"
                    :user="user"
                    force-type
                    ref="accountForm"
                >
                </AccountForm>
            </div>
        </template>
    </RegisterStep>
</template>

<script>
    import { clone } from '../../../util';
    import { getAccounts, handleUnauthenticated, postAccount, postOrderAccount } from "../../../api";
    import Icon from "../../ui/Icon.vue";
    import AccountForm from "../../AccountForm.vue";
    import AccountItem from "../../AccountItem.vue";
    import RegisterStep from "../RegisterStep.vue";
    import Field from "../../Field.vue";
    import ModalFormFooter from "../../ModalFormFooter.vue";

    export default {
        components: {
            ModalFormFooter,
            Field,
            RegisterStep,
            AccountItem,
            AccountForm,
            Icon,
        },
        props: {
            order: Object,
            course: Object,
            session: Object,
            nextRoute: Object,
            user: Object,
        },
        data() {
            return {
                ready: false,
                currentOrder: {
                    account_id: null,
                    ...clone(this.order),
                },
                currentAccount: null,
                accounts: null,
                errors: null,
                loading: false,
            }
        },
        computed: {
            filteredAccounts() {
                if(!this.currentOrder.account_type) {
                    return this.accounts;
                }
                if(this.currentOrder.account_type === 'organization') {
                    return this.accounts?.filter(account => account.is_organization);
                }
                return this.accounts?.filter(account => !account.is_organization);
            },
        },
        methods: {
            async init() {
                this.accounts = await getAccounts();
                if(this.currentOrder.account_id) {
                    this.currentAccount = this.accounts.find(account => account.id === this.currentOrder.account_id);
                }
                else if(!this.filteredAccounts?.length) {
                    this.currentAccount = {
                        is_organization: this.currentOrder.account_type === 'organization',
                    }
                }
                this.ready = true;
            },
            post({ account_id }) {
                const { courseId, sessionId, orderId } = this.$route.params;

                this.loading = true;
                this.errors = null;

                return postOrderAccount({
                    courseId,
                    sessionId,
                    orderId,
                    data: {
                        ...this.currentOrder,
                        account_id,
                    },
                })
                .catch(error => {
                    if(error.response?.status === 422) {
                        this.errors = error.response.data.errors;
                    }
                    return Promise.reject(error);
                })
                .finally(() => {
                    this.loading = false;
                });
            },
            async postAccount(account) {
                this.errors = null;
                this.loading = true;

                if(!account) {
                    return null;
                }

                return postAccount({
                    accountId: account.id,
                    data: {
                        is_organization: false,
                        ...account,
                    },
                })
                .catch(handleUnauthenticated)
                .catch(error => {
                    if(error.response.status === 422) {
                        this.errors = error.response.data.errors;
                        this.scrollToForm();
                    } else {
                        this.$emit('error', 'Impossible de créer de compte pour le moment, veuillez réessayer plus tard');
                    }
                    return Promise.reject(error);
                })
                .finally(() => {
                    this.loading = false;
                });
            },
            async handleStepSubmitted() {
                const account = await this.postAccount(this.currentAccount);
                const order = await this.post({
                    account_id: account?.id,
                });

                this.currentOrder = order;
                this.$emit('update:order', order);

               await this.$router.push({
                    ...this.nextRoute,
                    params: {
                        orderId: order.id,
                    },
                });
            },
            handleAccountSelected() {
                this.currentAccount = this.accounts.find(account => account.id === this.currentOrder.account_id);
                this.errors = null;
            },
            handleCreateClicked() {
                this.currentOrder.account_id = null;
                this.currentAccount = {
                    is_organization: this.currentOrder.account_type === 'organization',
                }
            },
            scrollToForm() {
                const rect = this.$el.querySelector('form').getBoundingClientRect();
                window.scrollBy(0, rect.top - 170);
            },
        },
        created() {
            this.init();
        },
    }
</script>
